import createCachedSelector from 're-reselect'
import { billingUsageKeyForProductFeature } from '../../featureTypes'
import { byProductFeatureCacheKey } from './byProductFeatureCacheKey'
import { selectLocalUsageForProduct } from './selectLocalUsageForProduct'

export const selectLocalUsageForProductFeature = createCachedSelector(
  selectLocalUsageForProduct,
  (_state, product) => product,
  (_state, _product, feature) => feature,
  (usage, product, feature) => {
    const key = billingUsageKeyForProductFeature(product, feature)
    return usage[key]
  }
)(byProductFeatureCacheKey)
